module.exports = __webpack_public_path__ + "static/media/HomeOutcomeCosAssessments.e36069f6.jpg";